(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["GDGC-featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gdgc-products-carousel')) {
    class GdgcProductsCarousel extends HTMLElement {
      connectedCallback() {
        this.disconnect();

        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.track = this.querySelector('[data-carousel-track]');
        this.navigation = this.querySelector('[data-carousel-navigation]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.progress = this.querySelector('[data-carousel-progress]');
        this.progressThumb = this.querySelector('[data-carousel-progress-thumb]');

        if (
          !this.viewport ||
          !this.track ||
          !this.navigation ||
          !this.previousButton ||
          !this.nextButton ||
          !this.progress ||
          !this.progressThumb
        ) {
          return;
        }

        this.items = Array.from(this.track.children);
        this.desktopColumns = Math.max(
          1,
          Number(this.dataset.desktopColumns) || 1
        );

        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateFrame = 0;

        this.scheduleUpdate = this.scheduleUpdate.bind(this);
        this.handlePrevious = () => this.scrollByPage(-1);
        this.handleNext = () => this.scrollByPage(1);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.previousButton.addEventListener(
          'click',
          this.handlePrevious,
          { signal: this.signal }
        );

        this.nextButton.addEventListener(
          'click',
          this.handleNext,
          { signal: this.signal }
        );

        this.viewport.addEventListener(
          'scroll',
          this.scheduleUpdate,
          { passive: true, signal: this.signal }
        );

        this.viewport.addEventListener(
          'keydown',
          this.handleKeydown,
          { signal: this.signal }
        );

        if (typeof this.mobileQuery.addEventListener === 'function') {
          this.mobileQuery.addEventListener(
            'change',
            this.scheduleUpdate,
            { signal: this.signal }
          );
        }

        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener(
            'resize',
            this.scheduleUpdate,
            { passive: true, signal: this.signal }
          );
        }

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.disconnect();
      }

      disconnect() {
        if (this.updateFrame) {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = 0;
        }

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        if (this.abortController) {
          this.abortController.abort();
          this.abortController = null;
        }
      }

      getItemStep() {
        const firstItem = this.items?.[0];

        if (!firstItem || !this.viewport || !this.track) {
          return this.viewport?.clientWidth || 0;
        }

        const trackStyles = getComputedStyle(this.track);
        const gap =
          Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;

        return firstItem.getBoundingClientRect().width + gap;
      }

      getVisibleCount() {
        if (this.mobileQuery?.matches) {
          return 1;
        }

        return Math.min(
          this.desktopColumns,
          Math.max(1, this.items?.length || 1)
        );
      }

      getMaximumScroll() {
        if (!this.viewport) return 0;

        return Math.max(
          0,
          this.viewport.scrollWidth - this.viewport.clientWidth
        );
      }

      scheduleUpdate() {
        if (this.updateFrame) return;

        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = 0;
          this.update();
        });
      }

      update() {
        if (!this.viewport || !this.navigation) return;

        const maximum = this.getMaximumScroll();
        const hasOverflow = maximum > 1;
        const position = Math.max(0, this.viewport.scrollLeft);
        const ratio = maximum
          ? Math.min(1, Math.max(0, position / maximum))
          : 0;

        const visible = this.getVisibleCount();
        const itemCount = this.items?.length || 0;
        const maximumIndex = Math.max(0, itemCount - visible);
        const percentage = itemCount
          ? Math.min(
              100,
              ((visible + maximumIndex * ratio) / itemCount) * 100
            )
          : 100;

        this.navigation.hidden = !hasOverflow;
        this.previousButton.disabled = !hasOverflow || position <= 1;
        this.nextButton.disabled =
          !hasOverflow || position >= maximum - 1;

        this.progressThumb.style.width = `${percentage}%`;
        this.progress.setAttribute(
          'aria-valuenow',
          String(Math.round(percentage))
        );
      }

      scrollByPage(direction) {
        if (!this.viewport) return;

        const itemsPerMove = this.mobileQuery?.matches
          ? 1
          : this.getVisibleCount();

        const target = Math.max(
          0,
          Math.min(
            this.getMaximumScroll(),
            this.viewport.scrollLeft +
              direction * this.getItemStep() * itemsPerMove
          )
        );

        const reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.viewport.scrollTo({
          left: target,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      handleKeydown(event) {
        if (
          event.target !== this.viewport ||
          !['ArrowLeft', 'ArrowRight'].includes(event.key)
        ) {
          return;
        }

        event.preventDefault();
        this.scrollByPage(event.key === 'ArrowLeft' ? -1 : 1);
      }
    }

    customElements.define(
      'gdgc-products-carousel',
      GdgcProductsCarousel
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const scrollToHashProduct = () => {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    let targetId;

    try {
      targetId = decodeURIComponent(hash.slice(1));
    } catch (error) {
      targetId = hash.slice(1);
    }

    const card = document.getElementById(targetId);
    if (!card) return;

    requestAnimationFrame(() => {
      card.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToHashProduct, { once: true });
  } else {
    scrollToHashProduct();
  }

  } catch(e) { console.error(e); }
})();
})();
